export default __webpack_public_path__ + "static/media/pi-zero.45bd7872.jpg";